import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";
import { useStore } from "../context/StoreContext";

const COLS = [
  { title: "Shop", links: [["All Gifts", "/gifts"], ["Watches", "/gifts/watches"], ["Dry Fruit Hampers", "/gifts/dry-fruits"], ["Gift Hampers", "/gifts/gift-hampers"], ["Personalized Gifts", "/gifts/personalized"]] },
  { title: "Shop By", links: [["Occasion", "/occasions"], ["Festival", "/festivals"], ["For Him", "/recipient/for-him"], ["For Her", "/recipient/for-her"]] },
  { title: "Support", links: [["Contact Us", "/contact"], ["FAQs", "/faq"], ["Track Order", "/track"], ["Shipping & Delivery", "/faq"], ["Exchange Policy", "/faq"], ["Payment Information", "/faq"]] },
  { title: "Company", links: [["About Savyron", "/#story"], ["Corporate Gifting", "/corporate"], ["Offers", "/offers"]] },
];

export default function Footer() {
  const { settings } = useStore();
  const c = settings?.content || {};
  const tagline = c.footer_tagline || "Gifts That Make Moments Memorable";
  const email = settings?.support_email || "founder@savyron.in";
  const address = settings?.address || "Plot No. 87, Sector 62, Noida – 201309";
  const instagram = settings?.instagram || "https://www.instagram.com/savyron.in";
  return (
    <footer className="border-t border-[#7E1E3F]/15 bg-[#FBF7F1]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid grid-cols-2 md:grid-cols-6 gap-10">
        <div className="col-span-2">
          <img src="/assets/savyron-logo.png" alt="SAVYRON — Gifts for Every Moment" className="h-16 w-auto" />
          <p className="mt-3 font-serif-lux italic text-[#857078]">"{tagline}"</p>
          <div className="mt-6 space-y-2 text-sm text-[#857078]">
            <p className="flex items-center gap-2"><Mail size={14} className="text-[#7E1E3F]" /> {email}</p>
            <p className="flex items-start gap-2"><MapPin size={14} className="text-[#7E1E3F] mt-1 shrink-0" /> {address}</p>
            <a href={instagram} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#7E1E3F] transition-colors" data-testid="footer-instagram">
              <Instagram size={14} className="text-[#7E1E3F]" /> @savyron.in
            </a>
          </div>
        </div>
        {COLS.map((col) => (
          <div key={col.title}>
            <p className="font-mono-lux text-[11px] uppercase tracking-[0.25em] text-[#7E1E3F] mb-4">{col.title}</p>
            <ul className="space-y-2.5">
              {col.links.map(([label, to]) => (
                <li key={label}>
                  <Link to={to} className="text-sm text-[#857078] hover:text-[#2E1A22] transition-colors">{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-[#7E1E3F]/10 py-6 text-center text-xs text-[#857078] font-mono-lux tracking-wider">
        © {new Date().getFullYear()} SAVYRON · PREPAID ORDERS ONLY · SECURE CHECKOUT
      </div>
    </footer>
  );
}
